const featureFlagsQueryKeys = {
  all: ["utility"] as const,
  featureFlagList: () =>
    [...featureFlagsQueryKeys.all, "featureFlagList"] as const,
};

export default featureFlagsQueryKeys;
